"use client";

import { c as _c } from "react/compiler-runtime";
import { getPostHogContext } from "@/lib/analytics/posthog";
import { useTurnstileFormSubmission } from "@/components/content/hooks/useTurnstileFormSubmission";
export function useContactFormSubmission(options) {
  const $ = _c(2);
  const t0 = options?.initialTopic ?? "";
  let t1;
  if ($[0] !== t0) {
    t1 = {
      name: "",
      email: "",
      phone: "",
      topic: t0,
      message: ""
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return useTurnstileFormSubmission("/api/contact", t1, _temp);
}
function _temp() {
  return {
    posthog_context: getPostHogContext()
  };
}